var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{class:_vm.displayFab ? 'fab_up' : 'fab_up fab_up--hidden',attrs:{"color":"primary","fab":"","small":"","transition":"fab-transition"},on:{"click":_vm.scrollTop}},[_c('v-icon',[_vm._v(" mdi-chevron-up ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }